export const COMFY_URL = "https://comfyui.by-air.xyz";
export const COMFY_TOKEN = "da44b0b0108cb0db4805531c4780ae10c630fee5d371bb7bd676d85c145b0f9a";